import React, { useEffect } from "react";
import { SvgHandler } from "../../../../svg-handler/svg-handler";
import GreenTickIcon from "../../../../../../assets/icons/green-tick.svg";
import "./success-message.module.css";

export const SuccessMessage = ({ message, mode, isUserLoginPage = false }) => {
  const redirectUrl = !isUserLoginPage ? global?.localStorage?.getItem("loginRedirectUrl") || "/" : null;

  useEffect(() => {
    setTimeout(() => {
      if (!isUserLoginPage) {
        global?.localStorage?.removeItem("loginRedirectUrl");
        window.location.href = redirectUrl;
      }
    }, 3000);
  }, [message]);

  return (
    <div styleName={`content-wrapper ${mode}`}>
      <SvgHandler xlinkHref={GreenTickIcon} width="24" height="24" viewBox="0 0 24 24" />
      <span styleName="message">{message}</span>
    </div>
  );
};
